import { render, staticRenderFns } from "./UserLanguage.vue?vue&type=template&id=2ac129cb&scoped=true"
import script from "./UserLanguage.vue?vue&type=script&lang=js"
export * from "./UserLanguage.vue?vue&type=script&lang=js"
import style0 from "./UserLanguage.vue?vue&type=style&index=0&id=2ac129cb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac129cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac129cb')) {
      api.createRecord('2ac129cb', component.options)
    } else {
      api.reload('2ac129cb', component.options)
    }
    module.hot.accept("./UserLanguage.vue?vue&type=template&id=2ac129cb&scoped=true", function () {
      api.rerender('2ac129cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/user/UserLanguage.vue"
export default component.exports